import { Component, OnInit } from '@angular/core';
import { HeaderFooterVisibilityService } from '@app/shared/services/header-footer-visibility.service';

@Component({
  selector: 'app-email-sent',
  templateUrl: './email-sent.component.html',
  styleUrls: ['./email-sent.component.scss'],
})
export class EmailSentComponent implements OnInit{

  constructor(private headerFooterVisibilityService: HeaderFooterVisibilityService) { }

  ngOnInit() {
    this.headerFooterVisibilityService.isFooterVisible = false;
  }

}
